import { motion } from 'framer-motion';
import { NationalFlagEmblem } from '../NationalFlagEmblems';
import { EASE_OUT_IOS, SPRING_POP, useReducedMotion } from '../../../lib/motion';

type EmblemProps = Parameters<typeof NationalFlagEmblem>[0];

/**
 * The league crest in the switcher header, with a one-shot "you've arrived in a new
 * world" flourish: when `flourish` is set (a real league switch just happened — see
 * LeagueSwitcher), the crest stamps in with a spring overshoot and a single accent
 * glow pings outward from behind it. Otherwise it renders flat with no entrance, so
 * ordinary navigation into the hub doesn't animate. Honours Reduce Motion.
 */
export function LeagueCrest({ flourish, ...emblem }: { flourish: boolean } & EmblemProps) {
  const reduce = useReducedMotion();
  const play = flourish && !reduce;

  return (
    <span className="relative inline-flex shrink-0">
      {play && (
        <motion.span
          aria-hidden
          className="pointer-events-none absolute -inset-2 rounded-full"
          style={{
            background:
              'radial-gradient(circle, rgba(36,197,106,0.5), rgba(36,197,106,0) 70%)'
          }}
          initial={{ opacity: 0.75, scale: 0.55 }}
          animate={{ opacity: 0, scale: 1.55 }}
          transition={{ duration: 0.55, ease: EASE_OUT_IOS }}
        />
      )}
      <motion.span
        className="relative inline-flex"
        initial={play ? { scale: 0.5, rotate: -14, opacity: 0 } : false}
        animate={play ? { scale: 1, rotate: 0, opacity: 1 } : undefined}
        transition={SPRING_POP}
      >
        <NationalFlagEmblem {...emblem} />
      </motion.span>
    </span>
  );
}
